export enum LayerIdEnum {
  TIANMAP_LAYER = 'TIANMAP_LAYER',
  TDTCVA_LAYER = 'TDTCVA_LAYER',
  WSM_LAYER = 'WSM_LAYER',
  ANCHOR_LAYER = 'ANCHOR_LAYER',
  SEARCHPOINT_LAYER = 'SEARCHPOINT_LAYER',
  INTER_LAYER = 'INTER_LAYER',
  BOUNDARY_LAYER = 'BOUNDARY_LAYER',
  STOPLINE_LAYER = 'STOPLINE_LAYER',
  GATE_LAYER = 'GATE_LAYER',
  OPENAREA_LAYER = 'OPENAREA_LAYER'
}

export const returnTileLayers = () => {
  return [
    {
      layerId: LayerIdEnum.INTER_LAYER,
      url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
      params: {
        FORMAT: 'image/png',
        TILED: true,
        LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_intersection`,
        STYLES: 'intersection'
      }
    },
    {
      layerId: LayerIdEnum.WSM_LAYER,
      url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
      params: {
        FORMAT: 'image/png',
        TILED: true,
        LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_lane`,
        STYLES: 'line-center'
      }
    },
    {
      layerId: LayerIdEnum.OPENAREA_LAYER,
      url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
      params: {
        FORMAT: 'image/png',
        TILED: true,
        LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_free_area`,
        STYLES: 'open-area'
      }
    },
    {
      layerId: LayerIdEnum.BOUNDARY_LAYER,
      url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
      params: {
        FORMAT: 'image/png',
        TILED: true,
        LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_boundary`,
        STYLES: 'line-boundary'
      }
    },
    {
      layerId: LayerIdEnum.STOPLINE_LAYER,
      url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
      params: {
        FORMAT: 'image/png',
        TILED: true,
        LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_stop_line`,
        STYLES: 'line-red'
      }
    },
    {
      layerId: LayerIdEnum.GATE_LAYER,
      url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
      params: {
        FORMAT: 'image/png',
        TILED: true,
        LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_gate`,
        STYLES: 'line-gate'
      }
    }
  ];
};

export enum BusinessType {
  Collection = 2, // 揽收
  Transport = 3 // 派送
}
export enum TaskType {
  OnGoing = 'OnGoing', // 进行中
  Finish = 'Finish', // 待交接任务
  Cancel = 'Cancel' // 已执行
}
export enum NewTaskType {
  CREATE = 'CREATE', // 创建
  DELIVERY = 'DELIVERY', // 派送
  COMPLETE = 'COMPLETE', // 完成
  CANCEL = 'CANCEL' // 取消
}
export enum OpenBoxSource {
  DEPART_OPEN = 'DEPART_OPEN', // 发车任务开箱
  DEPART_REOPEN = 'DEPART_REOPEN', // 发车任务再次开箱
  WORK_OPEN = 'WORK_OPEN', //  待交接任务开箱
  WORK_REOPEN = 'WORK_REOPEN' // 待交接任务再次开箱
}

export enum SubTaskType {
  Departure = 'departure', // 待发车任务
  Work = 'work', // 待交接任务
  Executed = 'executed' // 已执行
}
export interface TransportPoint {
  pointId: number;
  pointName: string;
}
export interface RoadInfo {
  roadCode: string;
  pointId: number;
  courierName: string;
  courierPhone: string;
  packageCount: number;
}

export enum TransportStatus {
  NOTASK = 0, // 无任务
  PROGRESS = 1, // 进行中
  FINISHED = 2, // 已完成
  OVERTIME = 3 // 超时
}
export const CHANGE_NAVBAR = 'CHANGE_NAVBAR';
export const SHOW_SPIDER_WEB_NAVBAR = 'SHOW_SPIDER_WEB_NAVBAR';
export const CHANGE_TASK_TAB = 'CHANGE_TASK_TAB';
export const BLOCK_ROUTE_NAVIGATION = 'BLOCK_ROUTE_NAVIGATION';
export const UNBLOCK_ROUTE_NAVIGATION = 'UNBLOCK_ROUTE_NAVIGATION';
export const REMOTE_CONTROL = {
  REMOTE_REQUEST_REMOTE_MOBILE_CONTROL: 'REMOTE_REQUEST_REMOTE_MOBILE_CONTROL',
  REMOTE_REQUEST_RESET_ABNORMAL_CONTROL: 'REMOTE_REQUEST_RESET_ABNORMAL_CONTROL'
};

/**
 * 扫码远控返回时用于跳过距离校验的 URL 参数
 */
export const REMOTE_CONTROL_SKIP_DISTANCE_PARAM = 'skipDistanceValidation';

export const COMMAND_TYPE = {
  MOBILE: 'MOBILE',
  SUPER: 'SUPER' // 强制遥控
};

// 强制遥控模式下的最高速度限制（m/s，绝对值）
export const FORCE_CONTROL_MAX_SPEED = 0.3;

export enum TakeoverStatus {
  TAKEOVER = 'TAKEOVER',
  TEMPORARY = 'TEMPORARY'
}
export enum SystemStatus {
  NORMAL = 'NORMAL',
  ABNORMAL = 'ABNORMAL',
  OFFLINE = 'OFFLINE'
}
export enum TakeOverType {
  TAKEOVER = 'TAKEOVER',
  TEMPORARY = 'TEMPORARY',
  NONE = 'NONE'
}
export const TakeOverTypeName = {
  TAKEOVER: '接管',
  TEMPORARY: '临时接管'
};
export const TakeOverTypeNameMap = new Map([
  ['TAKEOVER', '接管'],
  ['TEMPORARY', '临时接管']
]);

export enum TakeOverSourceType {
  MONITOR = 'MONITOR',
  MINI_MONITOR = 'MINI_MONITOR',
  REMOTE_JOYSTICK = 'REMOTE_JOYSTICK',
  WORKBENCH_MONITOR = 'WORKBENCH_MONITOR'
}

export const TakeOverSourceTypeName = {
  [TakeOverSourceType.MONITOR]: '监控',
  [TakeOverSourceType.MINI_MONITOR]: '小程序',
  [TakeOverSourceType.REMOTE_JOYSTICK]: '驾舱',
  [TakeOverSourceType.WORKBENCH_MONITOR]: '小哥工作台'
};

export const TakeOverSourceNameMap = new Map([
  [TakeOverSourceType.MONITOR, '监控'],
  [TakeOverSourceType.MINI_MONITOR, '小程序'],
  [TakeOverSourceType.REMOTE_JOYSTICK, '驾舱'],
  [TakeOverSourceType.WORKBENCH_MONITOR, '小哥工作台']
]);

export const REMOTE_COMMAND = {
  FLASH_LIGHT_OPEN: 'FLASH_LIGHT_OPEN',
  FLASH_LIGHT_CLOSE: 'FLASH_LIGHT_CLOSE',
  LOW_LIGHT_OPEN: 'LOW_LIGHT_OPEN',
  LOW_LIGHT_CLOSE: 'LOW_LIGHT_CLOSE',
  LEFT_TURN_LIGHT_OPEN: 'LEFT_TURN_LIGHT_OPEN',
  LEFT_TURN_LIGHT_CLOSE: 'LEFT_TURN_LIGHT_CLOSE',
  RIGHT_TURN_LIGHT_OPEN: 'RIGHT_TURN_LIGHT_OPEN',
  RIGHT_TURN_LIGHT_CLOSE: 'RIGHT_TURN_LIGHT_CLOSE'
};

export enum VehicleSupplier {
  JD = 'JD',
  NEOLIX = 'NEOLIX',
  RINO = 'RINO',
  WERIDE = 'WERIDE'
}

export enum VehicleSupplierText {
  JD = '京东',
  NEOLIX = '新石器',
  RINO = '白犀牛',
  WERIDE = '文远知行'
}

export enum VehicleState {
  INITIALIZATION = 'INITIALIZATION',
  CHASSIS_FAULT = 'CHASSIS_FAULT'
}

export enum VehicleStateText {
  INITIALIZATION = '初始化',
  CHASSIS_FAULT = '底盘故障'
}
